module.exports = __webpack_public_path__ + "static/img/14000362.6a101ee2.png";